import React from 'react';
import { connect } from 'react-redux';
import { Box, Container, Divider, Paper, Tab, Tabs, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ProjectState } from '../../app/reducer/project.reducer';
import { AuthState, getUser } from '../../app/reducer/auth.reducer';
import { FanState } from '../../app/reducer/fan.reducer';
import Carousel from 'react-material-ui-carousel';
import CampbellDiagram from '../../components/charts/CampbellDiagram';
import OctaveBand from '../../components/charts/OctaveBand';
import PerformanceCurveStatic from '../../components/charts/PerformanceCurveStatic';
import TorqueCurve from '../../components/charts/TorqueCurve';
import FanDetailsForm from '../../components/forms/FanDetailsForm';
import FanDetailsFormCustomer from '../../components/forms/FanDetailsFormCustomer';
import ProjectDetailsForm from '../../components/forms/ProjectDetailsForm';
import Datasheet from '../../components/Datasheet';
import GADrawingForm from '../../components/forms/GADrawingForm';
import { useAppSelector } from '../../app/hooks';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface CreateProjectFormWrapperProps {
  project: ProjectState,
  fan: FanState,
  auth: AuthState
}

const useStyles = makeStyles({
  indicator: {
    left: '0px !important',
    width: 'auto !important',
    
  },
  selectedTab: {
    fontSize:'15px',
    color: 'white !important', // or your primary color
    fontWeight: 700,
    backgroundColor: '#48bb98', // light highlight
    borderRadius: 4,
  },
});

function CreateProjectFormWrapper({ project, fan, auth }: CreateProjectFormWrapperProps) {
  const [index, setIndex] = React.useState(0);
  const user = useAppSelector(getUser);
  const classes = useStyles();

  const handleChange = (event: any, newValue: number) => {
    if (project.hasFan) {
      setIndex(newValue);
    }
  };
  const tabs = [
    "Project Details",
    "Fan Details"
  ];

  if (project.hasFan && auth.user?.userType !== 4 && auth.user?.userType !== 3) {
    tabs.push(
      "Octave Band",
      "Performance Curve",
      "Torque Curve",
      "Campbell Diagram"
    );
  }

  if (project.hasFan && user.user?.userType==1) {
    tabs.push(
      "GA drawing",
      "Datasheet"
    );
  }
   if (project.hasFan && user.user?.userType!=1) {
    tabs.push(
      "Datasheet"
    );
  }
  const slides = [
  <ProjectDetailsForm setIndex={setIndex} />,
    auth.user?.userType === 1
      ? <FanDetailsForm setIndex={setIndex} />
      : <FanDetailsForm setIndex={setIndex} />
  ];

  if (project.hasFan && auth.user?.userType !== 4 &&auth.user?.userType !== 3) {
    slides.push(
      <OctaveBand setIndex={setIndex} data={project.fanData.octaveBand} />,
      <PerformanceCurveStatic setIndex={setIndex} data={project.fanData.performance_curves} rpm={project.fanData.rpm} />,
      <TorqueCurve setIndex={setIndex} fanData={project.fanData} fanDetailsInput={project.projectData.fanDetails} />,
      <CampbellDiagram setIndex={setIndex} data={project.fanData.octaveBand.rpm} />
    );
  }

  if (project.hasFan && user.user?.userType==1) {
    slides.push(
      <GADrawingForm setIndex={setIndex} />,
      <Datasheet setIndex={setIndex} />
    );
  }
  if (project.hasFan && user.user?.userType!=1) {
    slides.push(
      <Datasheet setIndex={setIndex} />
    );
  }
  return (
    <Paper className="form-wrapper">
      <Typography variant="h5" gutterBottom>
        <b>ENTER PROJECT DETAILS</b>
      </Typography>
      <Divider /><br />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={index}
          onChange={handleChange}
          // variant="fullWidth"
          classes={{ indicator: classes.indicator }}
        >
          {tabs.map((label, i) => (
            <Tab
              key={label}
              label={label}
              {...a11yProps(i)}
              classes={{ selected: classes.selectedTab }}
            />
          ))}
        </Tabs>
      </Box>

      <Divider /><br />
      {/* <TabsComponent tabsArr={tabsArr} indexProp={index} hideNav={true}/> */}
      <Carousel
        index={index}
        animation="slide"
        autoPlay={false}
        indicators={false}
        swipe={false}
        navButtonsAlwaysInvisible
      >
        {slides}
      </Carousel>
    </Paper>
  );
}


interface IRootState {
  project: ProjectState;
  fan: FanState,
  auth: AuthState
}

export class EditProject extends React.Component<IRootState, {}> {

  render() {
    const { project, fan, auth } = this.props;
    return (
      <div className="page-wrapper">
        <Container maxWidth="xl">
          <CreateProjectFormWrapper project={project} fan={fan} auth={auth} />
        </Container>

      </div>
    );
  }

}

const mapStateToProps = (state: IRootState, ownProps = {}) => ({
  project: state.project,
  fan: state.fan,
  auth: state.auth,
});

export default connect(mapStateToProps)(EditProject)